<template>
  <v-dialog
      ref="dialog"
      v-model="open"
      :return-value.sync="date"
      persistent
      width="290px"
  >

    <v-date-picker
        v-model="date"
        locale="th"
        scrollable
    >
      <v-spacer></v-spacer>
      <v-btn
          color="primary"
          text
          @click="open = false"
      >
        Cancel
      </v-btn>
      <v-btn
          color="primary"
          text
          @click="onApply(date);open=false"
      >
        OK
      </v-btn>
    </v-date-picker>
  </v-dialog>
</template>


<script lang="ts">

import {Component, Vue} from 'vue-property-decorator'


@Component({
  components: {},
})
export default class DatePicker extends Vue {

  open: boolean = false
  date = ''

  onApply: Function = () => {
  }

  created() {
    this.$root.$on('openDatePicker', this.onOpen)
  }

  onOpen({date, onApply}) {
    if (this.open) return
    console.log('Emited', {date})
    this.date = date

    this.open = true

    this.onApply = onApply
  }

};

</script>
